import domReady from '@wordpress/dom-ready';

domReady(() => {
  const buttons = document.querySelectorAll('.wp-block-button__link');

  if (0 < buttons.length) {
    buttons.forEach((button) => {
      const btnText = button.textContent;
      const btnLabel = document.createElement('span');
      const firstIcon = document.createElement('span');
      const lastIcon = document.createElement('span');
      firstIcon.className = 'btn-icon btn-icon--first icon-Arrow';
      lastIcon.className = 'btn-icon btn-icon--last icon-Arrow';
      btnLabel.classList.add('btn-label');
      btnLabel.innerHTML = btnText;
      button.replaceChild(firstIcon, button.firstChild);
      button.appendChild(btnLabel);
      button.appendChild(lastIcon);
    });
  }
});
